/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-25 13:50:14
 * @LastEditors: shenlin
 * @LastEditTime: 2021-11-25 17:31:01
 */
const BASE_URL = '/lishui-gov'
const BASE = '/dev-api'
import request from '@/common/api/request'
// 专员列表
export const getCommissionerByPage = params => request(BASE_URL + '/commerManage/getCommissionerByPage', { params })
// 新增专员管理企业
export const addEntData = data => request.post(BASE_URL + '/commerManage/addEntData',  data )
// 专员管理的企业(已关联)
export const getCommissionerManagerByPage = params => request(BASE_URL + '/commerManage/getCommissionerManagerByPage', { params })
// 走访记录列表
export const myListByPage = params => request(BASE_URL + '/commerManage/myListByPage', { params })
// 解除绑定关系
export const deleteCommerManageaById = data => request.post(BASE_URL + '/commerManage/deleteCommerManageaById',  data )
// 查询关联企业
export const getEntDataByPage = params => request(BASE_URL + '/commerManage/getEntDataByPage', { params })
